import React, { useState } from "react";
import * as HTTPServices from "../api/HTTPServices";

const MeetingListContext = React.createContext();
const MeetingListContextSetState = React.createContext();

function MeetingListProvider({ children }) {
  const [meetingList, setMeetingList] = useState();

  return (
    <MeetingListContext.Provider value={meetingList}>
      <MeetingListContextSetState.Provider value={setMeetingList}>
        {children}
      </MeetingListContextSetState.Provider>
    </MeetingListContext.Provider>
  );
}

function useMeetingListState() {
  return React.useContext(MeetingListContext);
}

function useMeetingListSetState() {
  return React.useContext(MeetingListContextSetState);
}

function useUserMeetingListActions() {
  const updateMeetingList = useMeetingListSetState();
  let lang = localStorage.getItem("language");
  if (lang === null) {
    lang = "en";
  }
  const setUserMeetingList = () => {
    const RequestService = HTTPServices.getMethod(
      "meeting_user",
      `lang=${lang}`,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        updateMeetingList(response);
      }
    });
  };
  return { setUserMeetingList };
}

function useDrMeetingListActions() {
  const updateMeetingList = useMeetingListSetState();
  let lang = localStorage.getItem("language");
  if (lang === null) {
    lang = "en";
  }
  const setDrMeetingList = () => {
    const RequestService = HTTPServices.getMethod(
      "not_end_meeting_dr",
      `lang=${lang}`,
      "true"
    );
    const RequestServiceAllMeetings = HTTPServices.getMethod(
      "all_meeting_dr",
      `lang=${lang}`,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        updateMeetingList(response);
        RequestServiceAllMeetings.then(function (res) {
          updateMeetingList(res);
        });
      }
    });
  };
  return { setDrMeetingList };
}

export {
  useMeetingListState,
  useMeetingListSetState,
  useUserMeetingListActions,
  useDrMeetingListActions,
};
export default MeetingListProvider;
